export default __webpack_public_path__ + "d32fcd87144a023e30b2e9675ebe21f6.svg";